import { useId } from 'react';
import { FacebookFollowLink } from './FacebookFollowLink';
import { GetAlertsButton } from './GetAlertsButton';
import './SearchAlertSignupPanel.css';

function BetaIcon() {
  return <span className="search-alert-panel__beta-badge">BETA</span>;
}

const SHARE_LEDE =
  'We add more stores and products as more people find us. Know someone who shops online in Malta? A quick share helps us grow faster.';

/**
 * @param {{
 *   scopeLabel: string;
 *   scopeChips?: string[];
 *   variant?: 'empty' | 'end';
 *   showFacebook?: boolean;
 *   onShare: () => void;
 *   onWatch: () => void;
 * }} props
 */
export function SearchAlertSignupPanel({
  scopeLabel,
  scopeChips = [],
  variant = 'empty',
  showFacebook = true,
  onShare,
  onWatch,
}) {
  const titleId = useId();

  const heading =
    typeof scopeLabel === 'string' && scopeLabel.trim() !== ''
      ? scopeLabel.trim()
      : 'this search';

  const chips = Array.isArray(scopeChips)
    ? scopeChips.filter((c) => typeof c === 'string' && c.trim() !== '')
    : [];

  const facebookLocation =
    variant === 'end' ? 'search_support_panel_end' : 'search_support_panel_empty';

  const title =
    variant === 'end'
      ? 'You\u2019ve seen everything \u2014 watch for more or help us grow'
      : 'No results yet \u2014 watch for updates or help us add more';

  return (
    <aside
      className={`search-alert-panel search-alert-panel--${variant}`}
      aria-labelledby={titleId}
    >
      <div className="search-alert-panel__icon" aria-hidden="true">
        <BetaIcon />
      </div>
      <div className="search-alert-panel__content">
        <h2 id={titleId} className="search-alert-panel__title">
          {title}
        </h2>

        {chips.length > 0 && (
          <ul className="search-alert-panel__chips" aria-label="Search scope">
            {chips.map((chip) => (
              <li key={chip} className="search-alert-panel__chip">
                {chip}
              </li>
            ))}
          </ul>
        )}

        <div className="search-alert-panel__columns">
          <div className="search-alert-panel__share-column">
            <p className="search-alert-panel__email-label">
              Help us grow — share or follow
            </p>
            <div className="search-alert-panel__action-row">
              <button
                type="button"
                className="search-alert-panel__submit search-alert-panel__share-btn"
                onClick={onShare}
              >
                Share
              </button>
              {showFacebook && (
                <FacebookFollowLink location={facebookLocation}>
                  Follow
                </FacebookFollowLink>
              )}
            </div>
            <p className="search-alert-panel__column-lede">{SHARE_LEDE}</p>
          </div>

          <div className="search-alert-panel__watch-column">
            <p className="search-alert-panel__email-label">Watch this search</p>
            <GetAlertsButton
              onClick={onWatch}
              variant="toolbar"
              className="search-alert-panel__watch-btn"
              label={`Watch this search for ${heading}`}
            />
            <p className="search-alert-panel__column-lede">
              Get alerted when new products are added.
            </p>
          </div>
        </div>
      </div>
    </aside>
  );
}
